export default "__VITE_ASSET__BgXFmVO1__"